import React from 'react'
import OptionedProductSectionForm from 'ui-shared/Forms/OptionedProductSectionForm'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'

const PhysicalExperienceSectionCreate: React.FC = () => {
  return (
    <SectionWrapper title={'resources.physicalsections.createSection'}>
      <Create>
        <OptionedProductSectionForm entity="physicals" />
      </Create>
    </SectionWrapper>
  )
}

export default PhysicalExperienceSectionCreate
